
























































































import { ColorsList, formatDate, formattedDate, getDateFormattedAsMoment, ID, PRIVILEGE_KEYS } from '../../../core/utils';
import { Component, Prop, Mixins, Vue, Watch, Emit } from 'vue-property-decorator';
import Button from '../../../core/components/Button.vue';
import Combobox from '../../../core/components/Combobox.vue';
import PlusEyeButtons from '../../../core/components/PlusEyeButtons.vue';
import { NotificationStoreHelper } from '../../../core/mixins';
import Loading from 'vue-loading-overlay';
import { InsuranceServices } from '../../../insurance/api/InsuranceServices';
import ModalNewPolicy from '../ModalNewPolicy.vue';
import DeleteConfirmation from '../../../tracking/components/Geofences/DeleteConfirmation.vue';
import { FarmingRanchsBulkPolicy } from '../../../insurance/api/harvestModels';

@Component({
    components: {
        Loading,
        Button,
        Combobox,
        PlusEyeButtons,
        ModalNewPolicy,
        DeleteConfirmation
    }
})
export default class ModalAssignPolicyFarming extends Mixins(NotificationStoreHelper) {
    @Prop({default: false}) visible: boolean;
    @Prop({default(){return []}}) ranchIds: Array<ID>;
    @Prop({default: -1}) harvestId: ID;
    @Prop({default(){return []}}) policiesList: Array<object>;
    @Prop({default: null}) policyToSelect: object | null;

    policySelected: object | null = null;
    policySelectedRV: boolean = false;
    policyToPatch: null | object = null;
    visiblePolicy: boolean = false;

    // @Watch('policyToSelect')
    // observableWhenPolicyWasAddedToList(newPolicy) {
    //     if (newPolicy !== null) {
    //         this.updatePolicySelected(newPolicy);
    //     }
    // }

    // mounted(){
    //     if(this.policyToSelect != null){
    //         this.updatePolicySelected(this.policyToSelect);
    //     }
    // }


    updatePolicySelected(value) {
        this.policySelected = value;
    }
    updatePolicyRV(value) {
        this.policySelectedRV = value;
    }

    visibilityPolicyModal(value) {
        this.visiblePolicy = value;
    }

     createNewPolicy() {
        this.policyToPatch = null;
        this.visibilityPolicyModal(true);
    }

    modifyPolicy() {
        // console.log('modifyPolicy', this.policySelected);
        this.policyToPatch = this.policySelected;
        this.visibilityPolicyModal(true);
    }

    confirmationPolicy: boolean = false;
    pendingPolicy: boolean = false;
    confirmModalTitle: string = '';
    confirmModalBody: string = '';

    @Emit()
    addNewPolicyToPoliciesList(newPolicy: object){
        this.updatePolicySelected(newPolicy);
    }

    @Emit()
    updatePolicyInPoliciesList(updatedPolicy: object){
        this.updatePolicySelected(null)
        setTimeout(() => {
            this.updatePolicySelected(updatedPolicy);
        }, 0);
    }
   

    @Emit()
    closeModal(){}

    @Emit()
    refreshFarmingDetail() {}

    get formIsValid() {
        return this.policySelected != null;
    }



    showModalConfirm() {
        if(this.policySelected == null) return;

        this.confirmModalTitle = 'Asignar Poliza a Chacras';
        this.confirmModalBody = `¿Está seguro que desea asignar la poliza <b>"${this.policySelected['number']}"</b> a <b>${this.ranchIds.length}</b> chacras seleccionadas?`;
        this.confirmationPolicy = true;
    }

    confirmAction(value) {
        if (value) {
            this.confirmationPolicy = false;
            this.assignPoliciesToRanchs();
        } else {
            this.confirmationPolicy = false;
        }
    }

    getData():FarmingRanchsBulkPolicy {
            return {
                ranch_ids: this.ranchIds,
                policy: this.policySelected && this.policySelected['id'] ? this.policySelected['id'] : null
            };
    }

    showSuccessLoadingDialog(response, alternative_msg){
        this.$_successLoadingDialog({
            response: response,
            alternative_msg: alternative_msg
        });
        this.closeModal();
    }
    showCatchLoadingDialog(error, alternative_msg){
        this.$_catchLoadingDialog({
            response: error.response.data || {},
            alternative_msg: alternative_msg
        });
    }

    assignPoliciesToRanchs() {
        this.$_showLoadingDialog('Asignando Polizas...');

        let data:FarmingRanchsBulkPolicy = this.getData();
        this.pendingPolicy = true;
        InsuranceServices.updatePolicyToRanchs(
            data
        )
            .then(res => {
                this.showSuccessLoadingDialog(res, 'Polizas asignadas con éxito');
                this.refreshFarmingDetail();
            })
            .catch(err => {
                this.showCatchLoadingDialog(err, 'No se pudieron asignar las polizas');
            }).finally(() => {
                this.pendingPolicy = false;
            });
    }

   
}
